// extracted by mini-css-extract-plugin
export default {"page":"_404_page__Nahq0","textWrapper":"_404_textWrapper__QEDLa","button":"_404_button__Ewzex"};